export const COMPETITIVE_INTELLIGENCE_DEFAULT_PATH = '/competitive-intelligence/research'

export const UNIVERSE_AUTHENTICATED_PATHS = [
    '/dashboard',
    '/dashboard/me',
    '/trails',
    '/trails/:id',
    '/favorites',
    '/notifications',
    '/notifications/:id',
    '/approvals',
    '/access',
    '/training-approvals',
    '/training-approvals/:id',
    '/accelerator-certificate-approvals',
    '/certificates',
    '/competitive-intelligence',
    '/competitive-intelligence/research',
    '/competitive-intelligence/research/:id',
    '/competitive-intelligence/market',
    '/competitive-intelligence/assistants',
    '/competitive-intelligence/overview',
    '/analytics',
    '/faq',
    '/contact',
    '/live/:id',
    '/support',
    '/support/:id',
    '/myaccount',
    '/quiz/:id',
    '/survey/:courseId',
    '/search',
    '/sub-category/:categoryId/service-supports/:contentId',
    '/sub-category/:type',
    '/sub-category/:id/:type',
    '/mode/:type/:id',
    '/mode/:type/:id/:lesson',
    '/chat-agent',
    '/image-qualifier',
    '/staff/essentials-invites',
]
